export default __webpack_public_path__ + "static/media/relax-room.89c04c6e.jpg";